import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'

export default class CreditAgreement extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    this.displayName = 'Credit Agreement'
  }

  eligible () {
    return this.payment.booking.booking.paymentMethods.creditAgreementPayment
  }

  renderTermsAndConditions () {
    return this.payment.renderTermsAndConditions()
  }

  book () {
    return this.payment.booking.payWithCreditAgreement(this.payment.calculatePaymentAmount())
  }

  renderPaymentSummary () {
    return [
      <p class='final-payment-summary__headline' >Pay with credit agreement</p>,
      <button type='submit' class='btn-primary pay-now-btn'>Book</button>,
    ]
  }
}
